export const FIREBASE = {
  apiKey: "AIzaSyDLwAFjlnx2QJLEnH5cLkU4qjIufmE48Zg",
  authDomain: "vnsuperbrain.firebaseapp.com",
  databaseURL: "https://vnsuperbrain.firebaseio.com",
  projectId: "vnsuperbrain",
  storageBucket: "vnsuperbrain.appspot.com",
  messagingSenderId: "971982570664",
    persistance:true
}
